import { useEffect, type FunctionComponent } from "react";
import { useUserStore } from "../store/user.store";
import { useNavigate } from "react-router-dom";
import { AccountType } from "../constants/account-types.constants";

export const LayoutCommonScreen: FunctionComponent = () => {
  const { user, brands, token } = useUserStore();
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!token) {
      navigate("brands/auth/login");
      return;
    }
    if (!user) {
      navigate("brands/auth/login");

      return;
    }
    switch (user.accountType) {
      case AccountType.ADMIN:
        navigate("/admin");
        return;
      case AccountType.EPHEMERAL:
        navigate("/ephemeral/brand-dash/live-posts");
        return;
      case AccountType.BRAND:
        document.querySelector("body")?.classList.add("bg-white");
        console.log(brands, user);
        if (!brands?.length) {
          navigate("/brands/workspace/join");
          return;
        }

        navigate("/brands/campaigns/live");

        return;
      default:
        throw new Error("unknown account type");
    }
  }, [user, brands, navigate]);

  return null;
};
